<div class="page-error-wrapper" role="alert" aria-live="assertive">
  <mat-icon class="error-icon material-icons-outlined">{{ icon() }}</mat-icon>
  <div class="error-text-wrapper">
    <span class="error-title">{{ title() }}</span>
    @if (message()) {
      <span class="error-message">{{ message() }}</span>
    }
    @if (primaryActionLabel() || secondaryActionLabel()) {
      <span class="error-actions">
        @if (primaryActionLabel()) {
          @if (primaryActionLink()) {
            <a
              [href]="primaryActionLink()"
              class="error-link"
              [attr.aria-label]="primaryActionLabel()"
            >
              {{ primaryActionLabel() }}
            </a>
          } @else {
            <a
              href="#"
              class="error-link"
              (click)="onPrimaryActionClick($event)"
              [attr.aria-label]="primaryActionLabel()"
            >
              {{ primaryActionLabel() }}
            </a>
          }
        }
        @if (primaryActionLabel() && secondaryActionLabel()) {
          <span class="action-separator">or</span>
        }
        @if (secondaryActionLabel()) {
          @if (secondaryActionLink()) {
            <a
              [href]="secondaryActionLink()"
              class="error-link"
              [attr.aria-label]="secondaryActionLabel()"
            >
              {{ secondaryActionLabel() }}
            </a>
          } @else {
            <a
              href="#"
              class="error-link"
              (click)="onSecondaryActionClick($event)"
              [attr.aria-label]="secondaryActionLabel()"
            >
              {{ secondaryActionLabel() }}
            </a>
          }
        }
      </span>
    }
  </div>
</div>
